import React, { FC } from "react";
import { JCMSBanner, JCMSBannerProps } from "./../JCMSBanner";
import './JPageHeader.scss';
export const JPageHeader: FC<JCMSBannerProps> = props => {
    return (
        <JCMSBanner
            {...props}
            className={`jpage-header jpage-header-position-${props.options?.fluidResponsive ? 'fluid-responsive' : 'normal'}`}
            leftSideAlign="center"
        />
    )
}